import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div style={{ backgroundColor: '#ffffff', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      
      {/* --- MINIMALIST HERO --- */}
      <section className="py-2" style={{ 
        background: 'radial-gradient(at top left, #f1f5f9 0%, #ffffff 50%)',
        paddingTop: '80px !important'
      }}>
        <div className="container text-center">
            <h1 className="display-4 fw-bold mb-4" style={{ letterSpacing: '-2px', color: '#0f172a' }}>
                Privacy Policy
            </h1>
            <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }}>
                Reach out to the team at <span className="fw-bold text-dark">Zotrai</span> for support, demos, or partnerships.
            </p>
        </div>
      </section>

      {/* --- MAIN CONTACT SECTION --- */}
      <section className="py-1 mb-5">
        <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <p className="text-gray-900 fw-400"><strong>Zotrai</strong> (“Zotrai”, “we”, “our”, or “us”), operated by <strong>Saar Developers Code Private Limited</strong>, respects your privacy and is committed to protecting your personal data.</p>
                            <p className="text-gray-900 fw-400">This Privacy Policy explains how we collect, use, store, and share your information when you use the Zotrai Travel SaaS Portal (“Platform” or “Service”).</p>
                            <p className="text-gray-900 fw-400">By using our Platform, you agree to the practices described in this Privacy Policy.</p>
                            <h2 className="display3-size text-gray-900 fw-600">1. Information We Collect</h2>
                            <p>We may collect the following types of information:</p>
                            <h4 className="display2-size text-gray-900 fw-600">a.Client Information</h4>
                            <ul className="list-group mb-3 list-style-disc">
                                <li>Name, business name, email, phone number, billing details.</li>
                                <li>Login credentials (encrypted).</li>
                            </ul>
                            <h4 className="display2-size text-gray-900 fw-600">b.Customer Information (your end users)</h4>
                            <ul className="list-group mb-3 list-style-disc">
                                <li>Names, emails, phone numbers, booking preferences (only when entered into the Platform by you).</li>
                                <li>Payment details processed securely via Razorpay or other payment gateways (we do not store card details).</li>
                            </ul>
                            <h4 className="display2-size text-gray-900 fw-600">c.Technical Data</h4>
                            <ul className="list-group mb-3 list-style-disc">
                                <li>IP address, browser type, device details, cookies, and usage logs.</li>
                                <li>Activity within the Platform (logins, feature usage, reports generated).</li>
                            </ul>
                            <h4 className="display2-size text-gray-900 fw-600">d.Supplier Data</h4>
                            <ul className="list-group mb-3 list-style-disc">
                                <li>API keys and configuration details (Enterprise plan only).</li>
                            </ul>
                            <h4 className="display3-size text-gray-900 fw-600">2.How We Use Your Information</h4>
                            <p>We use collected data to:</p>
                            <ul className="list-group mb-3 list-style-disc">
                                <li>Provide and operate the Zotrai Platform.</li>
                                <li>Process subscriptions, payments, and Connect purchases.</li>
                                <li>Generate AI-based itineraries, reports, and analytics.</li>
                                <li>Send service updates, alerts, and support notifications.</li>
                                <li>Improve Platform performance and user experience.</li>
                                <li>Comply with legal obligations and prevent fraud.</li>
                            </ul>
                            <h4 className="display3-size text-gray-900 fw-600">3.How We Share Your Information</h4>
                            <p>We do not sell or rent personal information. We may share data with:</p>
                            <ul className="list-group mb-3 list-style-disc">
                                <li>Suppliers & Travel Providers (flights, hotels, packages) for bookings.</li>
                                <li>Payment Gateways (Razorpay, UPI, cards) for secure transactions.</li>
                                <li>Communication Services (WhatsApp, email providers) to deliver notifications.</li>
                                <li>Legal Authorities when required by applicable law.</li>
                            </ul>
                            <h4 className="display3-size text-gray-900 fw-600">4.Data Security</h4>
                            <ul className="list-group mb-3 list-style-disc">
                                <li>All sensitive data is encrypted in transit (HTTPS/SSL).</li>
                                <li>Passwords are stored using strong encryption and hashing.</li>
                                <li>Payment details are handled only by PCI-DSS compliant payment gateways (we never store card details).</li>
                            </ul>
                            <h4 className="display3-size text-gray-900 fw-600">5.Data Retention</h4>
                            <ul className="list-group mb-3 list-style-disc">
                                <li>Client account data is retained while the subscription is active.</li>
                                <li>Upon cancellation/termination, data is retained for up to 90 days unless legally required to keep longer.</li>
                                <li>You may request deletion of your data anytime by contacting us.</li>
                            </ul>
                            <h4 className="display3-size text-gray-900 fw-600">6.Cookies & Tracking</h4>
                            <ul className="list-group mb-3 list-style-disc">
                                <li>We use cookies to improve functionality, remember preferences, and analyze usage.</li>
                                <li>You can disable cookies in your browser, but some features may not work properly.</li>
                            </ul>
                            <h4 className="display3-size text-gray-900 fw-600">7.Your Rights</h4>
                            <p>Depending on your jurisdiction, you may have the right to:</p>
                            <ul className="list-group mb-3 list-style-disc">
                                <li>Access the personal data we hold about you.</li>
                                <li>Correct or update your data.</li>
                                <li>Request deletion of your data.</li>
                                <li>Opt out of marketing communications.</li>
                            </ul>
                            <p>Requests can be made via email: support@zotrai.com</p>
                            <h4 className="display3-size text-gray-900 fw-600">8.Children’s Privacy</h4>
                            <p>Zotrai is intended for businesses and professionals. It is not directed at children under 18, and we do not knowingly collect data from minors.</p>
                            <h4>9.International Users</h4>
                            <p>If you access Zotrai from outside India, please note that your data will be processed and stored in India and may be subject to Indian laws.</p>
                            <h4>10.Changes to This Policy</h4>
                            <p>We may update this Privacy Policy from time to time. Significant changes will be notified via email or dashboard alerts.</p>
                            <h4>11. Contact</h4>
                            <p>If you have any questions about this Privacy Policy or our data practices, please contact:</p>
                            <p>📧 Email: support@zotrai.com</p>
                            <p>📞 Phone: +91-7207642485</p>
                            <p>🏢 Saar Developers Code Private Limited, Hyderabad, India</p>
                        </div>
                    </div>
                    </div>
      </section>
    </div>
  );
}